import React from 'react';
import {
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
} from 'react-phone-number-input';

// Regular expressions for validation
const NAME_PATTERN = /^[\w\s@#&.-]+$/;
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Constants for validation
const MAX_NAME_LENGTH = 70;
const MAX_EMAIL_LENGTH = 100;


export const validateMobileNumber = (number) => {
  if (!number || number.trim().length === 0) {
    return { isValid: false, error: "Mobile number can't be empty" };
  }
  if (!formatPhoneNumberIntl(number)) {
    return {
      isValid: false,
      error: (
        <>
          Please enter a valid mobile number
          <br />
          with country code
        </>
      ),
    };
  }
  if (!isPossiblePhoneNumber(number)) {
    return {
      isValid: false,
      error: 'Please enter a valid mobile number',
    };
  }
  return { isValid: true, error: '' };
};


export const validateSenderName = (name) => {
  if (!name?.trim()) {
    return { isValid: false, error: "Sender name can't be empty" };
  }
  if (!NAME_PATTERN.test(name)) {
    return {
      isValid: false,
      error: 'Sender name can only contain letters, numbers and symbols',
    };
  }
  if (name.length > MAX_NAME_LENGTH) {
    return {
      isValid: false,
      error: `Sender name cannot exceed ${MAX_NAME_LENGTH} characters`,
    };
  }
  return { isValid: true, error: '' };
};


export const validateReceiverName = (name) => {
  if (!name?.trim()) {
    return { isValid: false, error: "Receiver name can't be empty" };
  }
  if (!NAME_PATTERN.test(name)) {
    return {
      isValid: false,
      error: 'Receiver name can only contain letters, numbers and symbols',
    };
  }
  if (name.length > MAX_NAME_LENGTH) {
    return {
      isValid: false,
      error: `Receiver name cannot exceed ${MAX_NAME_LENGTH} characters`,
    };
  }
  return { isValid: true, error: '' };
};


export const validateMessage = (message) => {
  if (!message?.trim()) {
    return { isValid: false, error: "Message can't be empty" };
  }
  return { isValid: true, error: '' };
};


export const validateDetails = (receiverMobile, receiverName) => {
  const mobileValidation = validateMobileNumber(receiverMobile);
  return Boolean(
    receiverName?.trim() &&
    receiverMobile &&
    mobileValidation.isValid &&
    isPossiblePhoneNumber(receiverMobile)
  );
};


export const validateEmail = (email) => {
  if (!email?.trim()) {
    return { isValid: false, error: "Email can't be empty" };
  }

  if (!EMAIL_PATTERN.test(email.trim())) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }

  if (email.length > MAX_EMAIL_LENGTH) {
    return { isValid: false, error: `Email cannot exceed ${MAX_EMAIL_LENGTH} characters` };
  }

  return { isValid: true, error: '' };
};

export const isValidateEmail = (email) => {
  if (!email || email.trim().length === 0) {
    return { isValid: false, error: "Email can't be empty" };
  }

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }

  return { isValid: true, error: '' };
};